<template>
  <div class="policy-upload-container">
    <h3>{{ policyType === 1 ? '上传投保单' : '上传电子保单' }}</h3>
    
    <div class="upload-section">
      <el-upload
        ref="upload"
        :action="uploadUrl"
        :headers="uploadHeaders"
        :on-success="handleUploadSuccess"
        :on-error="handleUploadError"
        :before-upload="beforeUpload"
        :file-list="fileList"
        :on-remove="handleRemove"
        :on-preview="handlePreview"
        name="fileVal"
        multiple
        accept=".pdf,.jpg,.png,.jpeg,.docx,.doc"
        list-type="picture-card"
      >
        <i class="el-icon-plus"></i>
        <div slot="tip" class="el-upload__tip">
          支持上传 PDF、JPG、PNG、JPEG、DOCX、DOC 格式文件，单个文件不超过10MB
        </div>
      </el-upload>
    </div>

    <!-- 操作按钮 -->
    <div class="button-container">
      <el-button type="primary" :loading="saving" :disabled="!hasUploadedFiles" @click="save">保存</el-button>
      <el-button @click="cancel">取消</el-button>
    </div>

    <!-- 图片预览对话框 -->
    <el-dialog
      title="图片预览"
      :visible.sync="previewDialogVisible"
      width="60%"
      center
      append-to-body
      :z-index="3000"
      :modal-append-to-body="false"
    >
      <div class="preview-content">
        <img :src="previewUrl" style="max-width: 100%; max-height: 500px;" alt="预览图片">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { uploadPingAnTrunkPolicyUrl } from '@/api/gxborder'

export default {
  name: 'PingAnTrunkPolicyUpload',
  props: {
    id: {
      type: [String, Number],
      required: true
    },
    policyType: {
      type: Number,
      default: 2 // 默认为电子保单
    }
  },
  data() {
    return {
      saving: false,
      proposal_stamp_url: [],
      fileList: [],
      uploadUrl: process.env.VUE_APP_FILE_UPLOAD_URL || 'http://test.rbbaotong.com/res/file/upload',
      uploadHeaders: {
        'Authorization': 'Bearer ' + this.$store.getters.token
      },
      previewDialogVisible: false,
      previewUrl: ''
    }
  },
  computed: {
    hasUploadedFiles() {
      return this.fileList.some(file => file.url && file.status === 'success')
    }
  },

  methods: {
    // 上传前检查
    beforeUpload(file) {
      const isValidType = ['application/pdf', 'image/jpeg', 'image/png', 'image/jpg', 
                          'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                          'application/msword'].includes(file.type)
      const isLt10M = file.size / 1024 / 1024 < 10

      if (!isValidType) {
        this.$message.error('只能上传 PDF、JPG、PNG、JPEG、DOCX、DOC 格式文件!')
        return false
      }
      if (!isLt10M) {
        this.$message.error('上传文件大小不能超过 10MB!')
        return false
      }
      return true
    },

    // 上传成功
    handleUploadSuccess(response, file, fileList) {
      if (response.err_code === 0) {
        // 更新文件对象的url属性，用于预览
        file.url = response.data
        file.response = response
        file.status = 'success'
        // 同步更新组件的fileList
        this.fileList = fileList
        this.proposal_stamp_url.push(response.data)
        this.$message.success('文件上传成功')
      } else {
        this.$message.error(response.err_msg || '文件上传失败')
        // 上传失败时从fileList中移除
        this.fileList = fileList.filter(item => item.uid !== file.uid)
      }
    },

    // 上传失败
    handleUploadError(err, file, fileList) {
      console.error('上传失败:', err)
      this.$message.error('文件上传失败，请重试')
    },

    // 移除文件
    handleRemove(file, fileList) {
      // 从proposal_stamp_url中移除对应的URL
      if (file.url) {
        const index = this.proposal_stamp_url.indexOf(file.url)
        if (index > -1) {
          this.proposal_stamp_url.splice(index, 1)
        }
      }
    },

    // 预览文件 - 使用el-upload自带的预览功能
    handlePreview(file) {
      if (file.url) {
        // 判断是否为图片
        if (/\.(jpg|jpeg|png|gif)$/i.test(file.url)) {
          this.previewUrl = file.url
          this.previewDialogVisible = true
        } else {
          // 非图片文件直接在新窗口打开
          window.open(file.url, '_blank')
        }
      }
    },

    // 保存
    async save() {
      // 从fileList中获取已上传成功的文件URL
      const uploadedFiles = this.fileList.filter(file => file.url).map(file => file.url)
      
      if (uploadedFiles.length === 0) {
        this.$message.warning(`请上传${this.policyType === 1 ? '投保单' : '电子保单'}文件`)
        return
      }

      // 确保id参数存在
      if (!this.id) {
        this.$message.error('缺少必要的ID参数')
        return
      }

      this.saving = true
      try {
        const data = {
          id: this.id,
          proposal_stamp_url: uploadedFiles, // 保持数组格式
          type: this.policyType  // 使用父组件传递的policyType值
        }

        console.log('保存数据:', data) // 添加调试日志
        const response = await uploadPingAnTrunkPolicyUrl(data)
        if (response.err_code === 0) {
          this.$message.success('保存成功')
          this.cancel()
        } else {
          this.$message.error(response.err_msg || '保存失败')
        }
      } catch (error) {
        console.error('保存失败:', error)
        this.$message.error('保存失败')
      } finally {
        this.saving = false
      }
    },

    // 取消
    cancel() {
      // 通知父组件关闭对话框
      this.$emit('close')
    }
  }
}
</script>

<style scoped>
.policy-upload-container {
  padding: 20px;
  max-width: 800px;
  margin: 0 auto;
}

h3 {
  text-align: center;
  margin-bottom: 20px;
  color: #333;
}

.upload-section {
  margin-bottom: 30px;
}



.button-container {
  text-align: center;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.button-container .el-button {
  margin: 0 10px;
  min-width: 80px;
}

.preview-content {
  text-align: center;
}

/* 预览弹框样式调整 */
::v-deep .el-dialog__wrapper {
  z-index: 3000 !important;
}

::v-deep .el-dialog {
  z-index: 3001 !important;
}

::v-deep .v-modal {
  z-index: 2999 !important;
}

/* 上传组件样式调整 */
::v-deep .el-upload--picture-card {
  width: 100px;
  height: 100px;
  line-height: 100px;
}

::v-deep .el-upload-list--picture-card .el-upload-list__item {
  width: 100px;
  height: 100px;
}
</style>